import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { Button, Card, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import { AddressFormModal } from '../../components/AddressFormModal'
import useAxios from '../../../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../../../types/pagination'
import AddressFilter, { IFilterMapped } from '../../components/AddressFilter'
import AddressTable from '../../components/AddressTable'
import PageUrls from '../../../../../../constants/page-urls'
import dayjs from 'dayjs'
import { IAddress } from '../../../../../../types/address'

const Menus: any[] = []

const AddressListPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [isModalCreateAddress, setIsModalCreateAddress] = useState<boolean>(false)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    search: queryStr.search?.length ? String(queryStr.search).toLowerCase() : undefined,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate ? dayjs(String(queryStr.endDate)).endOf('day').format() : undefined,
  })

  const onFilterChange = useCallback((newFilter: IFilterMapped) => {
    setFilter(newFilter)
  }, [setFilter])

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Setting.Address}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const addressList = useAxios<PaginationResponseInterface<IAddress>>
    ({
      method: 'GET',
      url: '/address',
      params: searchFilter,
    })

  const onUpdateAddressListSuccess = useCallback(async () => {
    try {
      await addressList.mutate()
    } catch (error) {
    }
  }, [searchFilter])

  return (
    <ContentWrapper>
      <Helmet title="รายการที่อยู่" />
      <AddressFormModal
        isOpen={isModalCreateAddress}
        onClose={(visible: boolean) => setIsModalCreateAddress(visible)}
        onUpdateAddressListSuccess={onUpdateAddressListSuccess}
      />
      <Grid
        container
        justifyContent="space-between"
        alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายการที่อยู่"
            routes={Menus}
            descriptions="รายการที่อยู่"
          />
        </Grid>
        <Grid item mb={2}>
          <Button variant="contained" size="large" startIcon={<AddIcon />}
            onClick={() => setIsModalCreateAddress(true)}>
            ที่อยู่
          </Button>
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}>
        <AddressFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <AddressTable
          isLoading={addressList.isLoading}
          data={addressList.data?.records ?? []}
          onUpdateAddressListSuccess={onUpdateAddressListSuccess}
          filter={{ ...filter }}
          onFilterChange={handleSearch}
          total={addressList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default AddressListPage